module.exports = __webpack_public_path__ + "static/b42cfc0a5095f70a24a298a0cc7b902f46b01e5f5cb8734f92ae6bb46b89d41e-718f999572cdfed5274480ac1390f2fe.png";